import { Button } from "@finbeat/react-toolkit";
import { MouseEventHandler } from "react";
import { Trans } from "react-i18next";
import { FaCloudUploadAlt } from "react-icons/fa";

const MerchantOrderContractUploadButton = ({ onClick, isUploading }: {
    onClick: MouseEventHandler;
    isUploading: boolean;
}) => {
    return (
        <Button
            color="default"
            className="w-100 h-75 btn-outline-secondary"
            onClick={onClick}
            disabled={isUploading}
        >
            {' '}
            <FaCloudUploadAlt />{' '}
            <Trans i18nKey="BackOfficeMerchantContractSignedUpload" />
        </Button>
    );
};

export default MerchantOrderContractUploadButton;
